import { HttpService } from '../http.service'

const http = new HttpService()

export async function getCustomReportUrl(code: string) {
  const result = await http.get<{
    url: string
  }>(`embed/url?id=${code}&titled=true`)

  return result.data.url
}